module.exports = __webpack_public_path__ + "static/media/reglamento_2.1221471f.png";